<template>
  <div v-for="(member, index) in membersOnline" :key="index">
    <h3 class="text--uppercase fs--xs">{{ $t(`participants.subtitle.${member.party}`) }}</h3>
    <ul class="list">
      <li :class="[member.status === 'online' && 'is--active', 'py--1']" :key="member.id">
        <div class="avatar me--2">
          {{ member.fullname?.charAt(0) ?? member.fullName?.charAt(0) }}
        </div>
        <div class="name me--4">
          <template
            v-if="user.isAssistant && (member.fullName === 'Guest' || member.fullname === 'Guest') && member.contact"
          >
            {{ member.contact }}
          </template>
          <template v-else>
            {{ member.fullName ?? member.fullname }}
          </template>
        </div>
        <div class="action ms--auto">
          <div v-if="member.profile">
            <a-icon
              v-if="!user.isInLobby"
              :name="user.networkIcon(member.profile.qualityNetwork).name"
              :color="user.networkIcon(member.profile.qualityNetwork).color"
              :width="24"
              :height="24"
            />
            <a-icon v-else :name="`wifi-on`" :color="`grey`" :width="24" :height="24" />
          </div>
        </div>
      </li>
    </ul>
  </div>

</template>
<script setup>
import AIcon from '@/components/AIcon.vue'
import {useUserStore} from '@/stores'
import {computed} from 'vue'
const user = useUserStore()
const membersOnline = computed(() => user.members.filter(a => a.status && a.status === 'online'))
</script>
<style lang="scss">
$participants-opacity: 0.4;
$participants-avatar-bg: $purple-200;
$participants-avatar-color: $primary;
$participants-name-max-width: 10rem;
  .list {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
  }

  .avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2rem;
    height: 2rem;
    background-color: $participants-avatar-bg;
    color: $participants-avatar-color;
    text-transform: uppercase;
    border-radius: 50%;
  }

  .name {
    max-width: $participants-name-max-width;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .is--active & {
      opacity: 1;
    }
  }

  .avatar,
  .name {
    transition-property: opacity;
    transition-duration: $duration-fast;
    opacity: $participants-opacity;

    .is--active > & {
      opacity: 1;
    }
  }

  .action {
    display: flex;
    justify-content: flex-end;
  }
</style>
